var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCilEducation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 17.6211L12.5 20.6973L17.9688 17.6211V14.371L19.5312 13.5029V18.5349L12.5 22.4899L5.46875 18.5349V13.5029L7.03125 14.371V17.6211Z",
    fill: "#3D5D07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.74512L23.4375 8.41641V9.77061L12.5 15.8468L3.125 10.6387V14.9533H1.5625V8.41641L12.5 2.74512ZM4.6875 9.71929L6.25 10.5873L12.5 14.0597L18.75 10.5873L20.3125 9.71929L21.3955 9.11763L12.5 4.50518L3.60454 9.11763L4.6875 9.71929Z",
    fill: "#3D5D07"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCilEducation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cil_education.ade5b1db.svg";
export { ForwardRef as ReactComponent };